module.exports = __webpack_public_path__ + "static/goto-afa46d42eb523683a3b564c292e47b26.png";